export default __webpack_public_path__ + "static/media/megane-rs-gallery-8.fb7292a5.jpg";